import type { ProductStatus } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

const PRODUCTS_PAGE_SIZE = 20;

interface ProductsListParams {
  readonly page: number;
  /** 빈 문자열이면 전체 상태. */
  readonly status: ProductStatus | '';
  readonly search: string;
}

/** 어드민 상품 목록 조회 — 빈 필터는 입력에서 제외한다(서버 계약). */
export const useProductsListQuery = ({ page, status, search }: ProductsListParams) =>
  trpc.productManagement.products.list.useQuery({
    page,
    limit: PRODUCTS_PAGE_SIZE,
    ...(status ? { status } : {}),
    ...(search ? { search } : {}),
  });
